import { useTranslation } from "react-i18next";
import image from '../../img/Academy/Education/image.png';
import icon_01 from '../../img/Academy/Education/icon_01.svg';
import icon_02 from '../../img/Academy/Education/icon_02.svg';
import icon_03 from '../../img/Academy/Education/icon_03.svg';
import icon_04 from '../../img/Academy/Education/icon_04.svg';

const cards = [
    {
        icon: icon_01,
        subtitle: 'academy.education.card_01.subtitle',
        text: 'academy.education.card_01.text',
        classes: 'col-start-1 col-end-1 row-start-1 row-end-1',
    },
    {
        icon: icon_02,
        subtitle: 'academy.education.card_02.subtitle',
        text: 'academy.education.card_02.text',
        classes: 'col-start-3 col-end-3 row-start-1 row-end-1',
    },
    {
        icon: icon_03,
        subtitle: 'academy.education.card_03.subtitle',
        text: 'academy.education.card_03.text',
        classes: 'col-start-1 col-end-1 row-start-2 row-end-2',
    },
    {
        icon: icon_04,
        subtitle: 'academy.education.card_04.subtitle',
        text: 'academy.education.card_04.text',
        classes: 'col-start-3 col-end-3 row-start-2 row-end-2',
    },
];

const Education = () => {
    const { t } = useTranslation();
    return (
        <section className="relative sm:pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative">
                <div className="flex flex-col md:grid grid-cols-3 gap-[15px] lg:gap-[20px]">
                    <div className="items-end min-h-[250px] md:min-h-[unset] mb-[25px] md:mb-0 px-[20px] sm:py-[24px] py-[15px] col-start-2 col-end-2 row-start-1 row-end-3 sm:rounded-[20px] w-[calc(100%+40px)] ml-[-20px] sm:w-[100%] sm:ml-0 relative overflow-hidden flex">
                        <h2 className="relative max-w-[300px] sm:max-w-[100%] z-10 open-sans text-[#fff] font-[700] lg:text-[28px] text-[17px]">
                            {t('academy.education.title')}
                        </h2>
                        <img className="absolute z-[1] inset-[0] w-[100%] h-[100%] object-cover object-center" src={image} alt='' />
                    </div>
                    {cards.map((card, index) =>
                        <div
                            className={`${card.classes} p-[20px] rounded-[20px] border-[2px] border-[#0C278080] md:min-h-[206px]`}
                            key={index}
                        >
                            <div className="flex items-center gap-[20px]">
                                <img className="sm:w-[47px] w-[45px]" src={card.icon} alt='' />
                                <h4 className="open-sans text-[#0C2780] font-[600] xl:text-[19px] text-[14px]">
                                    {t(card.subtitle)}
                                </h4>
                            </div>
                            <p className="sm:mt-[20px] mt-[15px] sm:text-[16px] text-[14px] font-[300] text-[#0C2780]">
                                {t(card.text)}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
};

export default Education;
